<b3-drawer
  [open]="open"
  size="md"
  overlay
  (b3-close)="close()"
  (b3-back)="close()">
  <b3-drawer-header
    heading="Detalhes da Operação"
    show-back
    back-aria-label="Fechar detalhes da operação">
  </b3-drawer-header>

  <b3-drawer-body>
    <div class="operation-details-drawer" *ngIf="!isLoading && details; else loadingState">
      <b3-tag
        size="sm"
        variant="filled"
        [icon]="operationTypeBadge.icon"
        [tone]="operationTypeBadge.tone"
        [label]="operationTypeBadge.label">
      </b3-tag>

      <div class="operation-details-drawer__grid operation-details-drawer__grid--2">
        <div class="operation-details-drawer__field">
          <span class="operation-details-drawer__label">Comitente do detentor</span>
          <span class="operation-details-drawer__value">{{ details.holderComitente }}</span>
        </div>
        <div class="operation-details-drawer__field">
          <span class="operation-details-drawer__label">Conta do adquirente</span>
          <span class="operation-details-drawer__value">{{ details.purchaserAccount }}</span>
        </div>
      </div>

      <div class="operation-details-drawer__field operation-details-drawer__field--full">
        <span class="operation-details-drawer__label">Comitente do adquirente</span>
        <span class="operation-details-drawer__value">{{ details.purchaserComitente }}</span>
      </div>

      <div class="operation-details-drawer__actions">
        <b3-button
          class="operation-details-drawer__confirm-btn"
          type="button"
          variant="filled"
          tone="default"
          (b3-click)="close()">
          <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
          Entendi
        </b3-button>
      </div>
    </div>

    <ng-template #loadingState>
      <p class="operation-details-drawer__loading">Carregando detalhes da operação...</p>
    </ng-template>
  </b3-drawer-body>
</b3-drawer>
